<template>
    <!-- 图片上传 -->
    <div class="pictureUploadBox">
        <!-- 公共头部 -->
        <job-header-simple header_title="身份认证"></job-header-simple>
        <!-- 新增内容部分 -->
       
        <div  class="pictureUploadContent" v-if="step=='0'">
            <!-- <van-cell 
            v-if="showCardInfo"
            @click="showCardImg"
            class="pictureUploadVanCell" 
            title-class="pictureUploadTitle"  
            title="身份证图片" 
            is-link 
            :arrow-direction="isShowImg?'up':'down'" 
            value="" /> -->
            <div class="CardImgContent" >
                <van-uploader
                    :before-delete="beforeDeleteFront"
                    v-model="frontPicArr"
                    :max-count="1"
                    :before-read="beforeRead"
                    class="upImg">
                    <img class="upBg" :src="frontBgImg">
                </van-uploader>
                <van-uploader 
                    :before-delete="beforeDeleteBack"
                    v-model="backPicArr"
                    :max-count="1"
                    :before-read="beforeRead"
                    class="upImg">
                    <img class="upBg" :src="backBgImg">
                </van-uploader>
                <van-divider  >照片上传要求</van-divider>
                <div  class="img">
                    <img src="@/assets/error_example.png" alt />
                </div>
            </div>
      
        </div>
        <div v-if="step=='1'" class="userCardInfo pictureUploadContent">
                <header class="header-title">身份信息</header>
                <van-field 
                label="姓名"  
                label-align="right"
                label-width="1.6rem"
                v-model="cardInfo.name" readonly />
                <van-field 
                label="证件号"  
                label-align="right"
                v-model="cardInfo.idNumber" 
                label-width="1.6rem"
                readonly />
                <van-field
                label-align="right"
                v-model="cardInfo.sexName"
                readonly
                name="picker"
                label-width="1.6rem"
                label="性别"
                placeholder="请选择性别"
                />
                <van-field 
                type="digit"
                maxlength="23" 
                label-align="right" 
                @input="cardInfo.bankCard = cardInfo.bankCard.replace(/[^\d]/g,'').replace(/....(?=.)/g, '$& ')" 
                @blur="changeAccount"
                label="银行卡号"  
                label-width="1.6rem"
                v-model="cardInfo.bankCard" 
                placeholder="请输入储蓄银行卡卡号" />
                <van-field 
                 label-width="1.6rem"
                 label-align="right"
                readonly 
                label="银行名称" 
                :value="cardInfo.bankName" />
                <van-field label="所属城市" 
                 label-width="1.6rem"
                 label-align="right"
                v-model="cardInfo.cityName" 
                is-link
                readonly 
                @click="isCityClicked = true" 
                placeholder="请选择所属城市" />
        </div>
        <div class="base-info">
            <p  v-if="step=='1'" class="note">
                温馨提示：请核对并确认身份证和银行卡信息，信息有误将无法完成认证。
            </p>
         <van-button
            v-if="step=='1'"
            type="info"
            size="large"
            class="goBackBtn"
            @click="bankUpload"
            color="#e3af22"
            >{{btnText1}}
          </van-button>
            <van-button
            type="info"
            size="large"
            @click="handleIndentify"
            color="#233BB7"
            >{{btnText}}
           </van-button>
        </div>
        <van-popup v-model="isCityClicked" position="bottom">
            <van-picker title="城市选择" show-toolbar :columns="cityList" @confirm="handleCityConfirm" @cancel="isCityClicked = false" />
        </van-popup>
        <van-popup v-model:show="showPicker" position="bottom">
        <van-picker
             show-toolbar
            :columns="columns"
            :default-index="selectedIndex"
            @confirm="chooseSex"
            @cancel="showPicker = false"
        />
        </van-popup>
    </div>
</template>
<script>
  import {mapMutations} from "vuex"
  import { saveEmployeeAccountMessage,employeeSaveToUserToCode,simVerifyUser,getMessageFromIdCard,saveToUserToCode } from "@/api/employee/request";
  import jobHeaderSimple from "@/components/header/header.vue";
  import captha from "@/components/captha.vue";
  import { getAllCity } from "@/api/contract/taskRequest";
  import api from "@/api/list";
  import { setToken } from "@/utils/auth";
  import {
    Button,
    Field,
    Toast,
    Uploader,
    Dialog,
    Divider,
    Popup,
    Picker,
    Cell
  } from "vant";
  
  export default {
    name: 'cannelIndex',
    components: {
      jobHeaderSimple,
      captha,
      [Button.name]: Button,
      [Field.name]: Field,
      [Toast.name]: Toast,
      [Cell.name]: Cell,
      [Uploader.name]: Uploader,
      [Dialog.name]: Dialog,
      [Divider.name]: Divider,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Dialog.Component.name]: Dialog.Component,
    },
    data() {
      return {
        isCityClicked:false,//是否展示选择银行卡城市
        cityList: [],//银行卡城市列表
        routerPath:"", //调转地址
        token:"",//携带的token
        step:"0", // 0 第一步 1第二步
        btnText1:"返回上一步，重新上传", //返回按钮
        btnText:"下一步", //确认按钮
        frontPicArr: [], //身份证正面照片
        backPicArr: [], //身份证反面照片
        username:this.$route.query.username,
        frontBgImg:require("@/assets/bg_front.png"), //身份证正面默认照片
        backBgImg:require("@/assets/bg_back.png"), //身份证反面默认照片
        loadingFlag:false,
        showPicker:false,
        selectedIndex:1,//性别弹窗选中项的位置
        isUploadCard:false,//是否上传过身份证正反面
        isHaveCardImg:false,//是否已在数据库存在身份证图片资源
        cardInfo:{ //身份证识别信息
            sexName:'',
            gender:'',
            idNumber:"",
            name:"",
            bankCard:"",//银行卡号
            cityName:"", //银行卡所属城市
            cityId:"",
            bankName:"" //银行卡名称
        },
        columns:[{text:'男',value:'0'},{text:'女',value:'1'}],
      };
    },
    computed:{
      
    },
    created() {
        getAllCity().then((res) => {
            this.cityList = res.data.data;
        });
        this.initData();
    },
    mounted() {
     
    },
    methods: {
      initData(){
        if(this.$route.query.front&&this.$route.query.back){
            let front = process.env.VUE_APP_FILE_PATH+this.$route.query.front;
            this.getBase64(front,dataURL=>{
                    this.frontBgImg = dataURL;
            })
            let back = process.env.VUE_APP_FILE_PATH+this.$route.query.back;
            this.getBase64(back,dataURL=>{
                    this.backBgImg = dataURL;
            })
            this.isHaveCardImg = true;
        }
    },
    // url 转base64
     getBase64(url, callback) {
        var Img = new Image(),
            dataURL = '';
        Img.src = url + '?v=' + Math.random();
        Img.setAttribute('crossOrigin', 'Anonymous');
        Img.onload = function() {
            var canvas = document.createElement('canvas'),
            width = Img.width,
            height = Img.height;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(Img, 0, 0, width, height);
            dataURL = canvas.toDataURL('image/jpeg');
            return callback ? callback(dataURL) : null;
        };
    },
    changeAccount() {
      let currentBankCard =  this.cardInfo.bankCard.replace(/\s/g, "")
      if (
        !currentBankCard ||
        typeof currentBankCard == "undefined"
      ) {
        Toast.fail("请填写银行卡号!");
        return false;
      }
      if (
        currentBankCard.length < 16 ||
        currentBankCard.length > 19
      ) {
        Toast.fail("银行卡号位数限定16~19位!");
        return false;
      }
      const toastLoading = Toast.loading({
        message: "正在获取银行卡号...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      saveToUserToCode({
        code: currentBankCard
      }).then((res) => {
        toastLoading.clear(); //关闭加载效果
        if (res.data.status == "200") {
          if (
            res.data.data.type == "" ||
            res.data.data.type == null ||
            res.data.data.type == undefined
          ) {
            Toast.fail("未知银行，请更换银行卡或联系客服");
          } else if (
            res.data.data.type == "储蓄卡" ||
            res.data.data.type == "借记卡"
          ) {
            if (res.data.data.code == 1) {
              Toast.fail(res.data.data.name + "存在风险交易，请更换银行卡");
            } else if (res.data.data.code == 2) {
              Toast.fail("暂不支持" + res.data.data.name + "，请更换银行卡");
            } else if (res.data.data.code == 3) {
              Toast.fail(
                res.data.data.name +
                  "银行" +
                  res.data.data.bin +
                  "不支持，请更换银行卡"
              );
            } else {
              this.cardInfo.bankName = res.data.data.name;
            }
          } else {
            Toast.fail("仅支持储蓄卡，请输入正确的储蓄卡号!!");
          }
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
        //点击确认城市
        handleCityConfirm(value, value2) {
            this.cardInfo.cityId = this.cityList[value2[0]].children[value2[1]].id;
            this.cardInfo.cityName = value.join("/");
            this.isCityClicked = false;
        },
        //点击展开图片详情
        // showCardImg(){
        //     this.isShowImg = !this.isShowImg;
        // },
        //选择性别
        chooseSex(value,index){ 
            this.cardInfo.sexName = value.text;
            this.cardInfo.gender = value.value;
            this.selectedIndex = index;
        }, 
        //返回上一步，重新上传
        bankUpload(){
            this.step = '0';//回到第一步
            this.btnText = '下一步';

        },
        //提交身份证去ocr认证
        ocr(param){
            Toast.loading({
                mask: true,
                message: "识别中...",
                duration: 0,
            });
            getMessageFromIdCard(param).then(res=>{
                Toast.clear()
                if (res.data.status == "200") { // 校验通过，调用身份证认证接口
                    this.step = "1";
                    this.isUploadCard = true; //身份证已认证通过
                    this.btnText = "信息无误，直接提交";
                    this.routerPath=res.data.data.routerPath;
                    let result = res.data.data;
                    this.cardInfo.name = result.name;
                    this.cardInfo.gender = result.gender;
                    this.cardInfo.idNumber= result.idNumber
                    this.cardInfo.employeeAccount = result.employeeAccount
                    if(result.gender.toString()==='0'){
                            this.cardInfo.sexName = "女";
                    }else{
                        this.cardInfo.sexName = "男";
                    }

                }else{ //校验失败
                    Toast.fail(res.data.message)
                }

            }).catch(err=>{
                Toast.clear()
                console.log(err)
            })
        },
        //去三要素认证
        simVerifyUserData(param){
            Toast.loading({
                mask: true,
                message: "认证中...",
                duration: 0,
            });
            simVerifyUser(param).then(res=>{
                 Toast.clear()
                let result = res.data;
                if (result.status == "200") { // 校验通过，调用身份证认证接口
                      let parm = {
                          "path": result.data.routerPath,
                          "query":{}
                       }
                      this.token = result.data.token;
                      setToken(result.data.token);
                      this.$store.commit("SET_TOKEN", result.data.token);
                    if(result.data.id && result.data.id!=null && result.data.id!=undefined && result.data.id!=""){
                        parm.query.id = result.data.id;
                    }
                    if(result.data.obj && result.data.obj!=null && result.data.obj!=undefined && result.data.obj!=""){
                        parm.query.obj = result.data.obj;
                    }
                      this.$router.push(parm);
                }else{ //校验失败
                    Toast.fail(res.data.message)
                }

            }).catch(err=>{
                 Toast.clear()
                console.log(err)
            })
        },
        //去认证
         handleIndentify() { 
            if(this.step === "0" && !this.isUploadCard){ //并且身份证是没有认证的身份证
                if (this.frontPicArr.length == 0 || this.backPicArr.length == 0) {
                    if(this.isHaveCardImg){ //后端传过来了身份证正反面
                        let param = {
                            taskId:decodeURIComponent(this.$route.query.taskId),
                            username:this.username,
                            back:this.backBgImg,
                            front:this.frontBgImg
                        }
                         this.ocr(param);
                    }else{
                    Dialog.alert({
                        title: "提示",
                        message: "请确认是否上传完整的证件正反面!",
                    }).then(() => {

                    });
                    }
              
                 } else {
                    let param={
                        taskId:decodeURIComponent(this.$route.query.taskId),
                        username:this.username,
                        back:this.backPicArr[0].content,
                        front:this.frontPicArr[0].content
                    }
                    this.ocr(param);
                  
                }
            }else if(this.step === '0' && this.isUploadCard){  //返回了上一步 但是身份证图片没有更换
                    this.step = "1";
                    this.btnText = "信息无误，直接提交";
            }else{ //确认信息 提交确认
             
                let flag = true;
                let str = "";
                if(this.cardInfo.bankName==="" ){
                    str = "请确认是否填写正确的银行卡!";
                    flag = false;
                }else if(this.cardInfo.cityId === ""){
                    str = "请确认是否选择银行卡城市!";
                    flag = false;
                }
                if(!flag){
                    Dialog.alert({
                        title: "提示",
                        message: str,
                    }).then(() => {

                    });
                }else{
                    const content = `<ul class='baseInfo'>
                                 <li><span class='labelText'>姓名<span></span></span><span class='colon'>:</span>${this.cardInfo.name}</li>
                                 <li><span class='labelText'>证件号<span></span></span><span class='colon'>:</span>${this.cardInfo.idNumber}</li>
                                 <li><span class='labelText'>性别<span></span></span><span class='colon'>:</span>${this.cardInfo.sexName}</li>
                                 <li><span class='labelText'>银行卡号<span></span></span><span class='colon'>:</span>${this.cardInfo.bankCard}</li>
                                 <li><span class='labelText'>银行名称<span></span></span><span class='colon'>:</span>${this.cardInfo.bankName}</li>
                                </ul>`
                Dialog.confirm({
                        title: "信息确认",
                        message: content,
                        confirmButtonText:"确认无误",
                        cancelButtonText:"取消",
                        className:'infoMark'
                    }).then(() => {
                        let addr1 = this.cardInfo.cityName.split("/");
                        let param1 = {
                            username:this.username,
                            taskId:decodeURIComponent(this.$route.query.taskId),
                            bankAccount:this.cardInfo.bankCard.replace(/\s/g,""),
                            provinceName: addr1[0],
                            cityName: addr1[1],
                            bankName:this.cardInfo.bankName,
                            employeeAccount:this.cardInfo.employeeAccount

                        }
                        this.simVerifyUserData(param1);

                    }).catch(() => {
                        

                    });
                }
      
               
          
                //已经认证成功，创建了账号 银行三要素认证
                // if(this.cardInfo.bankCard.length==0){
                //       Dialog.alert({
                //         title: "提示",
                //         message: "请填写银行卡号!",
                //         })
                //         return false
                // }
                // Toast.loading({
                // mask: true,
                // message: "认证中...",
                // duration: 0,
                // });
                // let addr = this.cardInfo.cityName.split("/");
                // api.simpleIdImage(
                //     {
                //     front: this.frontPicArr[0].content,
                //     back: this.backPicArr[0].content,
                //     bankCard: this.cardInfo.bankCard,
                //     provinceName: addr[0],
                //     cityName: addr[1],
                //     },
                //     { method: "post" }
                // )
                // .then((res) => {
                //     if (res.status == "200") {
                //         Toast.clear();
                //     if (res.data.status != "200") {
                //         Toast.fail("认证失败," + res.data.message); 
                //         return;
                //     } else if (res.data.status == "200") {
                //         Toast.loading({
                //         duration: 3000, // 持续展示 toast
                //         forbidClick: true, // 禁用背景点击
                //         loadingType: "spinner",
                //         message: "认证成功，即将跳转！",
                //         });
                //         this.$router.push({
                //         path: "/contractBase",
                //         query: { obj: this.$route.query.contractId, val: this.val },
                //         });
             
                //     }
                //     } else {
                //     //验证失败，请检查上传照片是否完成
                //     this.$toast({
                //         message: res.message,
                //     });
                //     }
                // });
            }
         
        },
        initCardInfo(){
            this.cardInfo.name = "";
            this.cardInfo.gender = "";
            this.cardInfo.idNumber= "";
            this.cardInfo.employeeAccount = "";
            this.cardInfo.sexName = "";
        },
        beforeDeleteBack(file,detail){
            return new Promise((resolve,reject)=>{
                this.$dialog.confirm({
                    message:'确定删除图片？'
            }).then(()=>{
                    this.backPicArr.splice(detail.index,1)
                    this.$toast.success('删除成功')
                    if(this.isUploadCard){
                        this.isUploadCard = false;
                        this,initCardInfo();
                    }
                    
                    resolve()
                }).catch((error)=>{
                    this.$toast.success('已取消')
                    reject(error)
                })
            })
        },
        beforeDeleteFront(file,detail){
            return new Promise((resolve,reject)=>{
                this.$dialog.confirm({
                    message:'确定删除图片？'
                }).then(()=>{
                    this.frontPicArr.splice(detail.index,1)
                    this.$toast.success('删除成功')
                    if(this.isUploadCard){
                        this.isUploadCard = false;
                        this,initCardInfo();
                    }
                    resolve()
                }).catch((error)=>{
                    this.$toast.success('已取消')
                    reject(error)
                })
            })
        },
        //初始化参数
        // initData(){
        //     this.isShowImg = false;
        //     this.showCardInfo = false;
        //     this.btnText = '上传';
        // },
        beforeRead(file) {
            if (
                file.type !== "image/jpeg" &&
                file.type !== "image/png" &&
                file.type !== "application/x-jpg" &&
                file.type !== "image/bmp"
            ) {
                Toast("请上传 jpg,png,jpeg,bmp 格式图片");
                return false;
            }
            //重新上传身份证重新认证
            // this.initData();
            // 改变数据之后就不取原来的值
            if(this.isUploadCard){
                this.isUploadCard = false;
                this,initCardInfo();
            }
            if(this.isHaveCardImg){
                this.isHaveCardImg = false;
            }
            this.frontPicLoading = true;
            return true;
        },
         ...mapMutations(['SET_ISUPLOADIMG','SET_FRONTIMG','SET_BACKIMG','SET_IDCARD','SET_USER_INFO'])
    },
  };
</script>
<style lang="less" >
.infoMark{
   .van-dialog__content{
    .baseInfo{
        line-height: normal;
        // padding: 10px 12px;
        li{
            line-height: normal;
            width: 100%;
            text-align: left;
            font-size: 15px;
            font-weight: bold;
            display: flex;
            align-items: center;
            .labelText{
                display: inline-block;
                padding-right: 6px;
                width: 62px;
                font-size: 14px;
                height: 22px;
                line-height: 22px;
                font-weight: normal;
                text-align: justify;
                white-space: normal;
                overflow: hidden;
                text-align-last: justify;
                span{
                     width: 100%;
                    height: 0;
                    display: inline-block;
                }
            }
            .colon{
                margin-right: 6px;
            }
        }
        }
    }

}
</style>
<style lang="less" scoped>

.goBackBtn{
    margin-bottom: 12px;
}

.pictureUploadBox {
    .pictureUploadContent{
        border-radius: 6px;
        background: #fff;
        margin: 12px 12px 24px;
        text-align: center;
        padding:24px 12px;
        .CardImgContent{
            padding-top: 12px;
        }
        .pictureUploadVanCell{
            padding: 0;
            &:active{
                background-color: #fff;
            }
            &::after{
                border-bottom: none;
            }
            
        }
        .pictureUploadTitle{
            text-align: left;
             font-size: 15px;
        }
        .upImg{
            width: 250px;
            height: 150px;
            background: #ebecf4;
            border-radius: 2px;
            margin: 0 auto 18px;
            /deep/.van-image{
             display: block;
             width: 220px;
             height: 121px;
             
            }
            /deep/.van-uploader__preview{
             display: block;
             width: 220px;
             height: 121px;
             padding: 14.5px 15px;
            }
            /deep/.van-uploader__preview-delete{
                top: 14.5px;
                right: 15px;
            }
            .upBg{
             display: block;
             width: 220px;
             height: 121px;
             padding: 14.5px 15px;
        }
          
        }
     
    }
    .userCardInfo{
        .header-title{
            text-align: left;
            font-size: 15px;
        }
    }
    .img {
        margin-top: -10px;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
    }
    .addbottom{
        margin-top: 34px;
        display: flex;
        justify-content: center;
        button{
            display: block;
            width: 160px;
        }
        button:first-child{
            margin-right: 22px;
        }
        button:last-child{
            background: #233BB7;
            border: 1px solid #233BB7;
        }
    }
    .base-info {
        margin: 8px 12px;
        padding: 10px 14px;
        .note{
            font-size: 13px;
            color: #999;
            margin-bottom: 12px;
        }
    }
}



</style>
<style lang="less">


</style>